<template>
  <page-option
    :disable-add="!checkAccess('rasterSource.create')"
    overflow-hidden
  >
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E">mdi-database-outline</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">{{ $t('sidebar.raster-source.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        :disableCreate="!checkAccess('rasterSource.create')"
        placeholder="Tìm kiếm theo tên, mô tả"
        @click:create="onCreateItem()"
      >
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:[`item.metadata`]="{ item }">
          <div v-if="item.metadata && item.metadata.length" class="py-1">
            <v-chip
              v-for="(row, index) in item.metadata.slice(0, 3)"
              :key="row.id || index"
              class="ma-1"
              label
              outlined
              small
            >
              {{ row.field }}: {{ row.value }}
            </v-chip>
            <span
              v-if="item.metadata.length > 3"
              class="text-caption grey--text"
            >
              +{{ item.metadata.length - 3 }}
            </span>
          </div>
          <span v-else class="grey--text">—</span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <RasterSourceDialog ref="dialog" @reset="onReset" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_RASTER_SOURCE } from '@api'
import { ConfirmBuilder } from '@utils'
import { EDIT_TYPE } from '@constant'
import RasterSourceDialog from './raster-source-dialog.vue'

export default {
  components: {
    FilterSearch,
    RasterSourceDialog,
  },
  data: (vm) => ({
    default_params: {},
    params: { search: '' },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('rasterSource.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('rasterSource.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Mô tả',
        align: 'start',
        sortable: false,
        value: 'description',
      },
      {
        text: 'Metadata',
        align: 'start',
        sortable: false,
        value: 'metadata',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
        width: 170,
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
        width: 170,
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
  }),
  computed: {
    api() {
      return API_RASTER_SOURCE
    },
  },
  methods: {
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.name },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_RASTER_SOURCE.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
